function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 22,
    height: 15.44,
    viewBox: "0 0 18.8 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: "1.7px",
    y: "2.5px",
    className: "st0",
    width: 15,
    height: 8.7,
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2.4,3.3 9.3,6.9 16,3.3 ",
    stroke: "#888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnv);
export default __webpack_public_path__ + "static/media/env.9c5f9cffb54dfa485aff0c79963ffe33.svg";
export { ForwardRef as ReactComponent };